const getValue = (value: string | { value: string }) => (typeof value === 'string' ? value : value.value);

export default (value: string | { value: string } | undefined, seperator = ' ') => {
    if (!value) return '';
    const currentValue = getValue(value);
    const withoutAlphabet = currentValue.replace(/([a-zA-Z])/g, '');
    const onlyNums = currentValue.replace(/[^\d]/g, '');
    if (withoutAlphabet !== currentValue || onlyNums.length !== 9) {
        if (onlyNums.length === 11) {
            return [onlyNums.slice(0, 4), onlyNums.slice(4, 7), onlyNums.slice(7, 11)].join(seperator);
        }
        return currentValue;
    }
    return [onlyNums.slice(0, 3), onlyNums.slice(3, 6), onlyNums.slice(6, 9)].join(seperator);
};
